/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalBrowsingHistory_requestListBrowsingHistories } from '../models/api_portalBrowsingHistory_requestListBrowsingHistories';
import type { api_portalBrowsingHistory_requestSaveBrowsingHistory } from '../models/api_portalBrowsingHistory_requestSaveBrowsingHistory';
import type { api_portalBrowsingHistory_responseListBrowsingHistories } from '../models/api_portalBrowsingHistory_responseListBrowsingHistories';
import type { api_portalBrowsingHistory_responseSaveBrowsingHistory } from '../models/api_portalBrowsingHistory_responseSaveBrowsingHistory';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BrowsingHistoryService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List Browsing Histories
     * 利用ユーザーの閲覧履歴を、閲覧日時の降順に最大30件取得する
     * @returns api_portalBrowsingHistory_responseListBrowsingHistories Successful response
     * @throws ApiError
     */
    public postBrowsingHistoriesList({
        body,
    }: {
        /**
         * requestListBrowsingHistories
         */
        body: api_portalBrowsingHistory_requestListBrowsingHistories,
    }): CancelablePromise<api_portalBrowsingHistory_responseListBrowsingHistories> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/browsing_histories/list',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save Browsing History
     * Save a user's browsing history
     * @returns api_portalBrowsingHistory_responseSaveBrowsingHistory Successful response
     * @throws ApiError
     */
    public postBrowsingHistoriesSave({
        body,
    }: {
        /**
         * requestSaveBrowsingHistory
         */
        body: api_portalBrowsingHistory_requestSaveBrowsingHistory,
    }): CancelablePromise<api_portalBrowsingHistory_responseSaveBrowsingHistory> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/browsing_histories/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
